import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const AccountsSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.98193 11.0847H9.09314C10.4075 11.0847 11.0751 10.4335 11.0751 9.06419V4.02052C11.0751 2.64684 10.4075 2 9.09314 2H3.98193C2.66754 2 2 2.64684 2 4.02052V9.06419C2 10.4335 2.66754 11.0847 3.98193 11.0847ZM4.00023 9.70401C3.57452 9.70401 3.37104 9.50054 3.37104 9.05551V4.01954C3.37104 3.58414 3.57452 3.38067 4.00023 3.38067H9.06516C9.50053 3.38067 9.70404 3.58414 9.70404 4.01954V9.05551C9.70404 9.50054 9.50053 9.70401 9.06516 9.70401H4.00023ZM14.9069 11.0847H20.0181C21.3325 11.0847 22 10.4335 22 9.06419V4.02052C22 2.64684 21.3325 2 20.0181 2H14.9069C13.5925 2 12.9249 2.64684 12.9249 4.02052V9.06419C12.9249 10.4335 13.5925 11.0847 14.9069 11.0847ZM14.9348 9.70401C14.4995 9.70401 14.296 9.50054 14.296 9.05551V4.01954C14.296 3.58414 14.4995 3.38067 14.9348 3.38067H19.9998C20.4351 3.38067 20.629 3.58414 20.629 4.01954V9.05551C20.629 9.50054 20.4351 9.70401 19.9998 9.70401H14.9348ZM3.98193 22.0096H9.09314C10.4075 22.0096 11.0751 21.3628 11.0751 19.9891V14.9455C11.0751 13.5761 10.4075 12.9346 9.09314 12.9346H3.98193C2.66754 12.9346 2 13.5761 2 14.9455V19.9891C2 21.3628 2.66754 22.0096 3.98193 22.0096ZM4.00023 20.629C3.57452 20.629 3.37104 20.4255 3.37104 19.9901V14.9541C3.37104 14.5091 3.57452 14.3056 4.00023 14.3056H9.06516C9.50053 14.3056 9.70404 14.5091 9.70404 14.9541V19.9901C9.70404 20.4255 9.50053 20.629 9.06516 20.629H4.00023ZM14.9069 22.0096H20.0181C21.3325 22.0096 22 21.3628 22 19.9891V14.9455C22 13.5761 21.3325 12.9346 20.0181 12.9346H14.9069C13.5925 12.9346 12.9249 13.5761 12.9249 14.9455V19.9891C12.9249 21.3628 13.5925 22.0096 14.9069 22.0096ZM14.9348 20.629C14.4995 20.629 14.296 20.4255 14.296 19.9901V14.9541C14.296 14.5091 14.4995 14.3056 14.9348 14.3056H19.9998C20.4351 14.3056 20.629 14.5091 20.629 14.9541V19.9901C20.629 20.4255 20.4351 20.629 19.9998 20.629H14.9348Z"
        fill={color}
      />
    </svg>
  );
};

export { AccountsSvg };
